import { render, staticRenderFns } from "./ServiceLogin.vue?vue&type=template&id=4ac7d27e&scoped=true"
import script from "./ServiceLogin.vue?vue&type=script&lang=js"
export * from "./ServiceLogin.vue?vue&type=script&lang=js"
import style0 from "./ServiceLogin.vue?vue&type=style&index=0&id=4ac7d27e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac7d27e",
  null
  
)

export default component.exports